import { setTimeAggregation } from '@process-advisor/process-miner/api/methods/time/setTimeAggregation';
import { activityTypes } from '@process-advisor/process-miner/api/methods/time/activityTypes'
import { setTimeActivityType } from '@process-advisor/process-miner/api/methods/time/setTimeActivityType'
import { setTimeActivity } from '@process-advisor/process-miner/api/methods/time/setTimeActivity'
import { setTimeDurationFormat } from '@process-advisor/process-miner/api/methods/time/setTimeDurationFormat'
import { setTimeMetric } from '@process-advisor/process-miner/api/methods/time/setTimeMetric'
import { formatTime } from '@process-advisor/process-miner/api/methods/time/formatTime'
import { setSelectedTimeTasks } from '@process-advisor/process-miner/api/methods/time/setSelectedTimeTasks'
import { saveAAGridState } from '@process-advisor/process-miner/api/methods/time/saveAAGridState'
import { setInitialAALoad } from '@process-advisor/process-miner/api/methods/time/setInitialAALoad'
import { setTimeInActivitySource } from '@process-advisor/process-miner/api/methods/time/setTimeInActivitySource'
import { changeShowColors } from '@process-advisor/process-miner/api/methods/time/changeShowColors';
import { getShowColors } from '@process-advisor/process-miner/api/methods/time/changeShowColors';
import { setTimeEndActivity} from '@process-advisor/process-miner/api/methods/time/setTimeEndActivity'


export const timeMethods = {
    setTimeAggregation,
    setTimeActivity,
    setTimeActivityType,
    activityTypes,
    setTimeDurationFormat,
    formatTime,
    setTimeMetric,
    setSelectedTimeTasks,
    saveAAGridState,
    setInitialAALoad,
    setTimeInActivitySource,
    changeShowColors,
    getShowColors,
    setTimeEndActivity
};
